import { withTypographyStyle } from './MBTypographyWithStyle';
import { MBTypographyStyles, fontTextRegularItalic, fontTextSemibold } from './typographyStyles';

const withStyle = withTypographyStyle;

/** @deprecated Use `Text` from `@shared/components/Text` with `size="h1"` instead. */
export const MBTextH1 = withStyle(MBTypographyStyles.h1);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="h1" monospace` instead. */
export const MBTextH1Mono = withStyle(MBTypographyStyles.h1Mono);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="h2"` instead. */
export const MBTextH2 = withStyle(MBTypographyStyles.h2);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="h3"` instead. */
export const MBTextH3 = withStyle(MBTypographyStyles.h3);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="h4"` instead. */
export const MBTextH4 = withStyle(MBTypographyStyles.h4);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="h4" weight="semibold"` instead. */
export const MBTextH4Semibold = withStyle(MBTypographyStyles.h4Semibold);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="h4" weight="light"` instead. */
export const MBTextH4Light = withStyle(MBTypographyStyles.h4Light);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="subtitle"` instead. */
export const MBTextSubtitle = withStyle(MBTypographyStyles.subtitle);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="body1"` instead. */
export const MBTextBody1 = withStyle(MBTypographyStyles.body1);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="body1" weight="semibold"` instead. */
export const MBTextBody1Bold = withStyle([MBTypographyStyles.body1, fontTextSemibold]);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="body1" italic` instead. */
export const MBTextBody1Inactive = withStyle([MBTypographyStyles.body1, fontTextRegularItalic]);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="body2"` instead. */
export const MBTextBody2 = withStyle(MBTypographyStyles.body2);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="body2" italic` instead. */
export const MBTextBody2Inactive = withStyle([MBTypographyStyles.body2, fontTextRegularItalic]);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="body2" weight="semibold"` instead. */
export const MBTextBody2Bold = withStyle([MBTypographyStyles.body2, fontTextSemibold]);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="overline"` instead. */
export const MBTextOverline = withStyle(MBTypographyStyles.overline);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="overline" weight="bold"` instead. */
export const MBTextOverlineBold = withStyle([MBTypographyStyles.overline, fontTextSemibold]);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="caption1"` instead. */
export const MBTextCaption1 = withStyle(MBTypographyStyles.caption1);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="caption1" weight="semibold"` instead. */
export const MBTextCaption1Bold = withStyle([MBTypographyStyles.caption1, fontTextSemibold]);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="caption2"` instead. */
export const MBTextCaption2 = withStyle(MBTypographyStyles.caption2);
/** @deprecated Use `Text` from `@shared/components/Text` with `size="caption2" weight="semibold"` instead. */
export const MBTextCaption2Bold = withStyle([MBTypographyStyles.caption2, fontTextSemibold]);
